import { render, staticRenderFns } from "./RoleAccess.vue?vue&type=template&id=4db0d1ee"
import script from "./RoleAccess.vue?vue&type=script&lang=js"
export * from "./RoleAccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports